// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"dc9b3ab5","977":"03df5f75"}[chunkId] + ".chunk.js";
};